import type { WrappedComponentProps } from 'react-intl-next';

import type { ContentTypeType } from '@confluence/editor-features/entry-points/types';
import type { BreadcrumbsItem } from '@confluence/editor-breadcrumbs/entry-points/breadcrumbTypes';
import type { ContentAppearance } from '@confluence/content-appearance/entry-points/contentAppearanceTypes';
import type { ContentClassificationMetadata } from '@confluence/data-classification/entry-points/useContentClassification';

export enum EditorTypes {
	NCS = 'ncs',
	SYNCHRONY = 'synchrony',
	TEMPLATE = 'template',
}

export type PreviewPageOwnProps = {
	editorActions: object;
	showTemplateVariablesInPreview?: boolean;
	spaceKey: string;
	title: string | null;
	Renderer: any;
	contentAppearance: ContentAppearance;
	isPreviewMode?: boolean;
	previewAsBlog?: boolean;
	editorType?: EditorTypes;
	contentId?: string;
	stagedContentId?: string | null;
	stagedSpaceKey?: string | null;
	space?: {
		alias: string | null;
		name: string | null;
		key: string | null;
		isSpaceAdmin?: boolean;
	} | null;
};

export type PreviewPageContainerProps = PreviewPageOwnProps & {
	contentId?: string;
	contentType: ContentTypeType | null;
	Renderer: any;
	isPageContentRenderer?: boolean;
};

export type PreviewPageActions = {
	changeEditorMode: (...args) => void;
};

export type PreviewPageFCProps = {
	breadcrumbs: BreadcrumbsItem[] | null;
};

export type PreviewPageComponentProps = PreviewPageContainerProps &
	PreviewPageActions &
	WrappedComponentProps;

export type ClassificationProps = {
	contentClassificationMetadata?: ContentClassificationMetadata;
};
